<template>
    <Dialog
        class="billingModal"
        :draggable="false"
        :visible="props.visible"
        modal
        @update:visible="(value) => !value && hideDialog()"
        :dismissableMask="true"  :style="{ width: '800px' }" :breakpoints="{ '400px': '75vw', '576px': '100vw' }" :pt="{header:{ class:'d-flex justify-content-end p-0 pt-2 pe-3 pe-md-2' },content: { class: 'p-0' },footer:{class:'pb-3 pt-3 bg-white'}}">
        <div class="d-flex flex-column justify-content-center align-items-center pb-40 px-3 p-md-0">
            <div class="token" style="width: 64px; height: 64px;">
                <img src="~/assets/images/logos/TopAuto_token_.svg" />

            </div>
            <h3 class="pt-3 fsz-20 lh-base text-gray-900">Solde de votre compte</h3>
            <p class="fsz-14 text-gray-500 lh-base text-center">Vous avez actuellement <b>{{ creditsBalance }} </b> crédits disponibles sur votre compte</p>
            <div v-if="showLowCredits" class="rounded bg-danger-50 border border-color-danger-600 mt-3 p-11 fsz-12 text-danger-600 d-flex align-items-center justify-content-center">
                <span class="d-flex align-items-center">
                    <i class="material-symbols-rounded fsz-18 me-1">info</i>
                </span>                               
                <span >Crédits insuffisants pour effectuer cette action. Veuillez recharger votre compte.</span>
                                
                                               
            </div>                                   
            <h1 class="fw-bold lh-lg fsz-64" 
                :class="creditsBalance === 0 ? 'text-danger-600' : 'text-gray-900' ">
                {{ creditsBalance }}
            </h1>
            <div class="d-flex flex-column flex-md-row gap-3">
                <div class="cursor-pointer rounded">
                    <div @click="goToHistorique" class="btn btn-bordless-primary-600 d-flex justify-content-center align-items-center fsz-14" >
                        <i class="material-symbols-rounded fsz-20 me-2">list</i>
                        <span>Voir l’Historique des Achats</span>
                    </div>
                   
                </div>
                <div class="cursor-pointer rounded">
                    <div class="btn btn-bordless-success-600 d-flex justify-content-center align-items-center fsz-14" @click="isCreditModalVisible = true" >
                        <i class="material-symbols-rounded fsz-20 me-2">help</i>
                        <span>Comment Utiliser mes Crédits</span>
                    </div>
                   
                </div>
            </div>
        </div>
            
            <div class="border border-start-0 border-end-0 border-1 border-color-gray-200 bg-gray-50 px-4 py-40">
            <h3 class="fsz-18 mb-2 fw-semiBold text-gray-900 lh-base">Achat de Crédits</h3>
            <p class="fsz-14 text-gray-600 mb-1">Besoin de plus de crédits ? Rechargez votre compte pour continuer à publier et modifier vos annonces. 
                Sélectionnez le pack de crédits qui vous convient le mieux.</p>
            <div class="gap-4 mt-4 d-flex justify-content-center row">               
                <div v-for="unit in unitsData" :key="unit.id" class="unit-card col-sm-5 col-md-6 d-flex flex-row justify-content-between align-items-center bg-white border border-1 rounded-3 p-3 cursor-pointer" :class="(selectedUnits?.id === unit.id) && 'checked'" @click="setUnits(unit)" >
                    <div class="d-flex justify-content-center align-items-center field-checkbox">
                        <span @click.stop>
                            <Checkbox
                                :pt="{ input: { class: 'rounded-circle' } }"
                                :modelValue="selectedUnits?.id === unit.id"
                                :binary="true"
                                :inputId="'unit-' + unit.id"
                                @update:modelValue="setUnits(unit)"
                            />
                        </span>
                    <div>
                        <h4 class="fsz-14 text-gray-900 lh-base"><b>{{ unit.addCredits }}</b> Crédits</h4>
                        <p class="fsz-12 lh-sm text-success-600">+{{ unit.freeCredits }} crédits bonus</p>
                    </div>
                    </div>
                    <span class="text-primary-600 fsz-18 lh-base fw-bold">{{ unit.price }} DT</span>
                </div>
            </div>
          
        </div>
        <template #footer>
            <div class="d-flex flex-column flex-sm-row justify-content-end">
                <Button
                  class="btn btn-solid-primary-600 buyUnitsBtn d-inline-flex align-items-center justify-content-center"
                  @click="buyUnits"
                  :disabled="!selectedUnits || isProcessing"
                >
                  <span v-if="isProcessing" class="spinner-border spinner-border-sm text-white me-2" role="status" aria-hidden="true"></span>
                  <span>Passer au Paiement</span>
                </Button>

            </div>
        </template>
    </Dialog>
    <DialogsCredit
        :visible="isCreditModalVisible" 
        @close="isCreditModalVisible = false" 
        @confirm="isCreditModalVisible = false"
    />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { getPerformance, trace } from "firebase/performance";

const props = defineProps({
  visible: { type: Boolean, default: false },
  lowCredits: { type: Boolean, default: false },
  requiredCredits: { type: Number, default: 0 },
});

const dash = useDashboardStore();
const emit = defineEmits(['update:visible']);
const selectedUnits =  ref<unitType | null>(null);
const isCreditModalVisible = ref(false);
const isProcessing = ref(false);
const router = useRouter();
const creditsBalance = computed(() => {
  return Number(dash.getUserProfil.freeCredits || 0) + Number(dash.getUserProfil.additionalCredits || 0);
});
const showLowCredits = computed(() => {
  if (props.requiredCredits > 0) {
    return creditsBalance.value < props.requiredCredits;
  }
  if (props.lowCredits) {
    return creditsBalance.value === 0;
  }
  return creditsBalance.value === 0;
});

interface unitType {
  id: number;
  addCredits: number;
  freeCredits: number;
  price: number;
  price_mil: number;
  des: string;
  packId: string;
}
const unitsData: unitType[] = [
  { id: 1, addCredits: 10, freeCredits: 0, price: 10, price_mil:10000, packId: 'pack_10C', des: '10 crédit' },
  { id: 2, addCredits: 20, freeCredits: 4, price: 20, price_mil:20000, packId: 'pack_20C', des: '20 crédit' },
  { id: 3, addCredits: 50, freeCredits: 10, price: 45, price_mil:45000, packId: 'pack_50C', des: '50 crédit' },
  { id: 4, addCredits: 100, freeCredits: 20, price: 80, price_mil:80000, packId: 'pack_100C', des: '100 crédit' },
];

const setUnits = (unit: unitType) => {
  if (selectedUnits.value?.id === unit.id) {
    selectedUnits.value = null;
  } else {
    selectedUnits.value = unit;
  }

};

const buyUnits = async () => {
  if (isProcessing.value) return;
  let fetchTrace;
  if (selectedUnits.value) {
    const performance = getPerformance();
    fetchTrace = trace(performance, 'proceed_to_payment');
    fetchTrace.start();
    isProcessing.value = true;
    try {
      await dash.generateClicToPayUrl(selectedUnits.value.packId);
    } finally {
        isProcessing.value = false;
        if (fetchTrace) {
          fetchTrace.stop();
        }
    }

   /* await dash.incrementUserCredits(selectedUnits.value.addCredits, selectedUnits.value.freeCredits,selectedUnits.value.price,selectedUnits.value.des);
    await dash.getMyFactures()
    emit('update:visible', false);
    selectedUnits.value = null;*/

  }
};
const hideDialog = ()=>{
    isProcessing.value = false;
    selectedUnits.value = null;
    emit('update:visible', false);
}

const goToHistorique = () => {
  emit('update:visible', false);
  router.push({ path: '/dashboard/parameter/abonnement_et_transaction', hash: '#historique-achats' });
};

</script>



